function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorWarningGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.54,
    height: 16.54,
    viewBox: "0 0 16.54 16.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 35"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16426",
    d: "M11.67 3.4a8.27 8.27 0 1 0 8.27 8.27 8.267 8.267 0 0 0-8.27-8.27zm0 14.227a1.249 1.249 0 1 1 1.246-1.246 1.249 1.249 0 0 1-1.246 1.246zm1.512-10.294-.471 6.361a.173.173 0 0 1-.173.162H10.8a.173.173 0 0 1-.173-.162l-.471-6.361a1.515 1.515 0 1 1 3.025 0z",
    transform: "translate(-3.4 -3.4)",
    style: {
      fill: "#7c7c7c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWarningGray);
export default __webpack_public_path__ + "static/media/error-warning_gray.4410bd487ec2aea179f7c085e3c42835.svg";
export { ForwardRef as ReactComponent };